(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["f2g-floating-actions"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('.f2g-floating-actions:not([data-initialized])');

    roots.forEach((root) => {
      root.dataset.initialized = 'true';

      const popover = root.querySelector('[data-help-popover]');
      const closeButton = root.querySelector('[data-help-close]');
      const whatsappButton = root.querySelector('[data-whatsapp-button]');
      const delay = Number(root.dataset.helpDelay) || 30000;
      const sessionKey = root.dataset.helpSessionKey || 'f2g-whatsapp-help-v1';
      const startedKey = `${sessionKey}:started`;
      const shownKey = `${sessionKey}:shown`;

      if (!popover || !whatsappButton) return;

      const primaryBuyButton = document.querySelector('.product-details .add-to-cart-button');

      if (primaryBuyButton && 'IntersectionObserver' in window) {
        const primaryBuyObserver = new IntersectionObserver(
          ([entry]) => root.classList.toggle('is-primary-buy-visible', entry.isIntersecting),
          { threshold: 0.2 }
        );
        primaryBuyObserver.observe(primaryBuyButton);
      }

      const readSession = (key) => {
        try {
          return sessionStorage.getItem(key);
        } catch (_) {
          return null;
        }
      };

      const writeSession = (key, value) => {
        try {
          sessionStorage.setItem(key, value);
        } catch (_) {
          return;
        }
      };

      const dismiss = () => {
        popover.classList.remove('is-visible');
        window.setTimeout(() => {
          popover.hidden = true;
        }, 200);
        writeSession(shownKey, '1');
      };

      closeButton?.addEventListener('click', dismiss);
      whatsappButton.addEventListener('click', () => writeSession(shownKey, '1'));

      window.setTimeout(() => whatsappButton.classList.add('has-arrived'), 1100);

      if (readSession(shownKey) === '1') return;

      let startedAt = Number(readSession(startedKey));
      if (!Number.isFinite(startedAt) || startedAt <= 0) {
        startedAt = Date.now();
        writeSession(startedKey, String(startedAt));
      }

      const remaining = Math.max(0, delay - (Date.now() - startedAt));

      window.setTimeout(() => {
        if (!root.isConnected || readSession(shownKey) === '1') return;

        popover.hidden = false;
        window.requestAnimationFrame(() => popover.classList.add('is-visible'));
        whatsappButton.classList.add('is-nudging');
        writeSession(shownKey, '1');

        window.setTimeout(() => whatsappButton.classList.remove('is-nudging'), 1700);
      }, remaining);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
